module.exports = __webpack_public_path__ + "static/media/25-2.e56a4713.mp3";